import {
  IColumn,
  ICommandBarItemProps,
  Stack,
  TooltipHost,
  Icon,
} from "@fluentui/react";
import { useBoolean } from "@fluentui/react-hooks";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DialogBaseAlert } from "../../../components/Dialog/DialogBaseAlert";
import { DialogBaseError } from "../../../components/Dialog/DialogBaseError";
import { DialogBaseSuccess } from "../../../components/Dialog/DialogBaseSuccess";
import { DialogBaseWait } from "../../../components/Dialog/DialogBaseWait";
import { HeadingBar } from "../../../components/Generic/HeadingBar";
import { TableBase } from "../../../components/Table/TableBase";
import { IPagination } from "../../../interfaces/base/ITable";
import { Ifilter } from "../../../interfaces/IFilter";
import {
  ITransporte,
} from "../../../interfaces/ITransporte";
import PersonaService from "../../../services/PersonaService";
import { ConfigHelper } from "../../../utils/Helper/configHelper";
import {
  _initialFilter,
  stackTokensHorizontal,
  _initialPagination,
} from "../../../utils/Helper/helper";
import { IconHelper } from "../../../utils/Helper/iconHelper";
import ThemeBase from "../../../utils/Theme/themeBase";
import React from "react";
import UseAsignarEmpresa from "./UseAsignarEmpresa";
import PanelAsignarEmpresa from "./PanelAsignarEmpresa";
import { IRequestEliminarEmpresa } from "../../../interfaces/ubicacion/IUbicacion";
import { LugarMovilizacionService } from "../../../services/movilizacion/LugarMovilizacionService";

export const UbicacionEmpresa = () => {
  let navigate = useNavigate();

  const location = useLocation();
  const { state } = location;

  const dataMov = state.data;

  const [hidden, setHidden] = useState(false);
  const [column, setColumn] = useState<IColumn[]>([]);
  const [filter, setFilter] = useState<Ifilter>(_initialFilter);
  const [nombreEmpresaMov, setNombreEmpresaMov] = useState("");
  const [requestEliminar, setRequestEliminar] =
    useState<IRequestEliminarEmpresa>({
      empresaId: "",
      lugarMovilizacionId: dataMov.lugarMovilizacionId,
    });

  //Estados
  const [mensajeTransaccion, setMensajeTransaccion] = useState("");

  /* Pagination */
  const [currentPage, setCurrentPage] = useState(
    _initialPagination().currentPage
  );
  const [pageSize, setPageSize] = useState(_initialPagination().pageSize);
  const [total, setTotal] = useState(_initialPagination().total);

  const [pager, setPager] = useState<IPagination>({
    ..._initialPagination(),
    onSizeChange: (pageSize) => setPageSize(pageSize),
  });

  const [
    isOpenAsignar,
    { setTrue: openPanelAsignar, setFalse: closePanelAsignar },
  ] = useBoolean(false);

  const { movilizacionEmpresa, getUbicacion } = UseAsignarEmpresa(
    dataMov,
    isOpenAsignar
  );
  //dialog
  const [hideAlertEliminar, { toggle: toggleHideAlertEliminar }] =
    useBoolean(true);
  const [hideWaitEliminar, { toggle: toggleHideWaitEliminar }] =
    useBoolean(true);
  const [hideSuccessEliminar, { toggle: toggleHideSuccessEliminar }] =
    useBoolean(true);
  const [hideErrorEliminar, { toggle: toggleHideErrorEliminar }] =
    useBoolean(true);

  /* Hook */
  useEffect(() => {
    reloadInitial();
  }, []);

  /* Hook Pagination */
  useEffect(() => {
    setPager({
      ...pager,
      currentPage: currentPage,
    });

    if (filter) {
      setFilter({
        ...filter,
        skip: (currentPage - 1) * pageSize,
        take: pageSize,
      });
    }
  }, [currentPage]);

  useEffect(() => {
    setPager({
      ...pager,
      onSizeChange: (pageSize) => setPageSize(pageSize),
      total: total,
    });
  }, [total]);

  const EliminarMarca = (request: IRequestEliminarEmpresa) => {
    toggleHideWaitEliminar();
    LugarMovilizacionService.EliminarLugarMovilizacionEmpresa(request)
      .then((res) => {
        if (res.status == 200) {
          reloadInitial();
          toggleHideWaitEliminar();
          toggleHideSuccessEliminar();
        }
      })
      .catch(function (error) {
        if (error.response) {
          toggleHideWaitEliminar();
          setMensajeTransaccion(error.response.data.detail);
          toggleHideErrorEliminar();
        }
      });
  };

  /* Api */
  const dataVehiculo = (param = filter) => {
    PersonaService.getTransporte(param)
      .then((res) => {
        setTotal(res.data.total);
        setHidden(true);
      })
      .catch((err) => {
        alert(err.message);
        setHidden(true);
      });
  };

  /* Function */
  const reloadInitial = (param = filter) => {
    setHidden(false);
    setTitleColumn();
    dataVehiculo(param);
    getUbicacion();
  };

  const _leftItemBar = () => {
    const _items: ICommandBarItemProps[] = [
      {
        ...IconHelper.ICON_BACK,
        onClick: () =>
          navigate(`${ConfigHelper.urlBase()}/configuraciones/lugar`),
      },
      {
        ...IconHelper.ICON_RELOAD,
        onClick: () => reloadInitial(),
      },
      {
        ...IconHelper.ICON_ADD,
        onClick: openPanelAsignar,
      },
    ];

    return _items;
  };

  const setTitleColumn = () => {
    let col: IColumn[] = [
      {
        key: "column1",
        name: "N°",
        fieldName: "contador",
        minWidth: 300,
        maxWidth: 300,
        isResizable: false,
        isCollapsible: true,
        data: "number",
        isPadded: true,
        onRender: (item: ITransporte, index?: number) => (
          <>{index !== undefined ? index + 1 : ""}</>
        ),
      },
      {
        key: "column2",
        name: "Empresa de Transporte",
        fieldName: "nombreEmpresa",
        minWidth: 300,
        maxWidth: 300,
        isResizable: true,
        data: "number",
        isPadded: true,
      },
      {
        key: "column3",
        name: "Usuarion Registra",
        fieldName: "nombreUsuarioRegistra",
        minWidth: 300,
        maxWidth: 300,
        isRowHeader: true,
        isResizable: true,
        data: "string",
        isPadded: true,
      },

      {
        key: "column12",
        name: "Opciones",
        fieldName: "opciones",
        minWidth: 100,
        maxWidth: 100,
        isResizable: true,
        isCollapsible: true,
        data: "number",
        onRender: (item) => (
          <>
            <Stack horizontal tokens={stackTokensHorizontal}>
              <TooltipHost content={`Validar información`}>
                <TooltipHost content={`Elminar`}>
                  <Icon
                    iconName="Delete"
                    className={ThemeBase.classNamesIcon.iconFont}
                    // style={iconDetalleStyle}
                    onClick={() => {
                      setNombreEmpresaMov(item.nombreEmpresa);
                      setRequestEliminar({
                        empresaId: item.empresaId,
                        lugarMovilizacionId: dataMov.lugarMovilizacionId,
                      });

                      toggleHideAlertEliminar();
                    }}
                  />
                </TooltipHost>
              </TooltipHost>
            </Stack>
          </>
        ),
      },
    ];
    setColumn(col);
  };

  const _onChangeTextFilter = (
    ev?: React.ChangeEvent<HTMLInputElement>,
    newValue?: string
  ) => {
    if (newValue !== undefined) {
      if (newValue === "") {
        _onClearFilter();
      } else {
        setFilter({
          ...filter,
          search: newValue,
        });
      }
    }
  };

  const _onPressFilter = (newValue: string) => {
    let f: Ifilter = {
      ..._initialFilter(),
      search: newValue,
    };

    setFilter(f);
    setCurrentPage(_initialPagination().currentPage);
    reloadInitial(f);
  };

  const _onClearFilter = () => {
    let f: Ifilter = {
      ..._initialFilter(),
    };

    setFilter(f);
    reloadInitial(f);
  };

  return (
    <>
      <HeadingBar
        title="Asignar Empresa"
        subTitle={dataMov.nombre}
        searchChange={_onChangeTextFilter}
        searchHandler={_onPressFilter}
        searchValue={filter.search ?? ""}
        onClearHandler={_onClearFilter}
      ></HeadingBar>

      <TableBase
        leftBar={_leftItemBar()}
        column={column}
        data={movilizacionEmpresa}
        // pagination={pager}
        isLoading={!hidden}
      ></TableBase>

      {/* Panel - Reporte - Telerik */}

      <PanelAsignarEmpresa
        dataMov={dataMov}
        isOpen={isOpenAsignar}
        onDismiss={closePanelAsignar}
        reloadInitial={reloadInitial}
      />

      <div id="dialogAlertElimnar">
        <DialogBaseAlert
          hideDialog={hideAlertEliminar}
          toggleHideDialog={toggleHideAlertEliminar}
          title="¡Atención!"
          subText={`¿Está seguro que desea eliminar a ${nombreEmpresaMov}?`}
          onclickButtonPrimary={() => EliminarMarca(requestEliminar)}
        />
      </div>
      <div id="dialogWaitElimnar">
        <DialogBaseWait
          hideDialog={hideWaitEliminar}
          toggleHideDialog={toggleHideWaitEliminar}
        />
      </div>
      <div id="dialogSuccessElimnar">
        <DialogBaseSuccess
          hideDialog={hideSuccessEliminar}
          toggleHideDialog={toggleHideSuccessEliminar}
          subText={`Se ha eliminadoo ${nombreEmpresaMov}?`}
        />
      </div>
      <div id="dialogErrorEliminar">
        <DialogBaseError
          hideDialog={hideErrorEliminar}
          toggleHideDialog={toggleHideErrorEliminar}
          subText={mensajeTransaccion}
        />
      </div>
    </>
  );
};
